import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Container, Anchor } from 'Components/core';
import Hamburger from 'Components/Hamburger';
import { layout, colors } from 'Constants';
import isUrl from 'is-url';

import { ApiStore, Subscribe } from 'Store';

// Components
import HamburgerContent from './components/HamburgerContent';
import CODES from 'Root/libs/analytics/CodeDef';
import { toArray } from 'Root/libs/array';

const Header = styled.header`
  position: sticky;
  height: 80px;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 10px 0px #aaa;
  z-index: 100;
`;

const Nav = styled.nav`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //max-width: 1800px;//${layout.maxWidth};
  width: 100%;
  height: 100%;
  margin: auto;

  .mobile {
    display: none !important;
  }

  // ${layout.breakpoints.mobile}

  @media screen and (max-width:1000px) {
    .mobile {
      display: flex !important;
    }

    .desktop {
      display: none !important;
    }
  }

  > * + * {
    margin-left: 16px;
  }
  .triangle {
    position: absolute;
    fill: rgba(249, 70, 45);
    top: 40%;
    margin-left: 10px;
  }
`;

const NavItem = styled.span`
  position: relative;
  color: ${colors.text};
  transition: 0.2s color;
  cursor: pointer;
  padding: 16px 0;
  font-size:16px ;
  font-weight:bold ;

  :hover {
    color: ${colors.accent};
  }

  > .dropdown {
    display: none;
  }

  :hover > .dropdown {
    display: flex;
  }
`;

const NavLink = props => (
  <Anchor {...props} underline={false}>
    <NavItem>{props.children}</NavItem>
  </Anchor>
);

const NavDropdown = styled.div`
  position: absolute;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 16px;
  background: ${colors.background};
  box-shadow: 0 0 10px 0px #aaa;

  > * {
    padding: 8px 4px;
  }
`;

const NavLinkLogo = styled.a.attrs(props => ({
  target: '_blank',
  href: props.to
}))``;

const NavLogo = styled.img`
  max-height:80px;
  max-width:80vw;
  padding:5px;
  width:auto ;
  height: auto;
  margin-right:20px;
  @media(max-width:${layout.breakpoints.mobile}) {
    max-width:31vw;
    padding:10px;
    width:auto;
    align-self:center ;
    
  }
 
`;

const NavWrapper=styled.div`
display:flex ;
a 
{
  margin-right:40px ;
}

`;

const shouldShowImage=(state)=>{

  if(!state.coBrandLogoURL)
  {
    return false;
  }
  const arr= toArray(state.coBrandLogoURL);
  if(arr.length===0)
  {
    return false;
  }
  return true;

};

// TODO: URL for Logo?
// FIXME: coBrandUrl
export default props => {
  const [hamburgerSelected, setHamburgerSelected] = useState(false);
  const [benefitsOpen, setBenefitsOpen] = useState(true);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Header>
            <Nav>
              <div style={{display:'flex',alignItems:'flex-end'}}>
                <NavLink code={CODES.HEADER_SITE_VISIT} to={'/'}>
              
                  <NavLogo
                    src={state.brandInfo?.logo}
                    alt={state.brandInfo?.name}
                  />
                </NavLink>
                {(shouldShowImage(state)) && (
                  <NavLogo src={state.coBrandLogoURL} alt="Co-Brand Logo" />             )}
              </div>
              <NavWrapper>
                
                <NavLink to="/" className="desktop" code={CODES.HOME_CLICK}>
                Home
                </NavLink>

                {state?.asaCoverage?.eligible && <NavLink className="desktop" to="/eligibility">
                Eligibility
                </NavLink>}
        
                {state.includeAsaCoverage && <NavLink  className="desktop" to="/coverage-periods-rates">
              Coverage Rates
                </NavLink>
                }
              
                {state.includeAsaPlan && <NavLink className="desktop" to="/plan-details">
              Plan details
                </NavLink>}

           
        

                {state.includeAsaWhereForCare && <NavLink className="desktop" to="/care">
                Access Care
                </NavLink>}


                {<NavLink className="desktop" to="https://players.brightcove.net/3707693280001/default_default/index.html?videoId=6309466729112" target='_blank'>
                Healthcare 101
                </NavLink>}
                {state.includeAsaImportantContacts&&
                 <NavLink className="desktop" to="/Contacts">
              Contacts
                 </NavLink>}
              </NavWrapper>

              <NavItem
                className="mobile"
                onClickCapture={() => setHamburgerSelected(!hamburgerSelected)}
                style={{padding: '24px 12px'}}
              >
                <Hamburger selected={hamburgerSelected} />
              </NavItem>

              <HamburgerContent
                state={state}
                style={{ display: hamburgerSelected ? undefined : 'none' }}
                className="mobile"
                closeHamburger={() => setHamburgerSelected(false)}
              />
            </Nav>
          </Header>
        );
      }}
    </Subscribe>
  );
};
